import React, { useEffect, useState } from "react";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import Button from "@material-ui/core/Button";
import "./CompanyCreationModal.scss";
import getStyles from "./getStyles";
import InputField from "../InputField";
import {
  Box,
  Checkbox,
  FormControl,
  MenuItem,
  Tab,
  TextField,
  Typography
} from "@material-ui/core";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import ChipInput from "material-ui-chip-input";
import CancelIcon from "@material-ui/icons/Cancel";
import BackspaceIcon from "@material-ui/icons/Backspace";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import Tabs from "@material-ui/core/Tabs";
import StorageIcon from "@material-ui/icons/Storage";
import AddIcon from "@material-ui/icons/Add";
import DropDown from "../DropDown";
import FormHelperText from "@material-ui/core/FormHelperText";
import { Currency } from "../../containers/NewOrderContainer/types";
import DeleteIcon from "@material-ui/icons/Delete";
import DialogContentText from "@material-ui/core/DialogContentText";
import { Autocomplete } from "@material-ui/lab";
import CheckBoxOutlineBlankIcon from "@material-ui/icons/CheckBoxOutlineBlank";
import CheckBoxIcon from "@material-ui/icons/CheckBox";

interface TabPanelProps {
  children?: React.ReactNode;
  index: any;
  value: any;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <Typography
      component="div"
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box p={3}>{children}</Box>}
    </Typography>
  );
}

const CompanyCreationModal = (props: any) => {
  const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
  const checkedIcon = <CheckBoxIcon fontSize="small" />;

  const classes = getStyles();
  const [name, setName] = useState<string>("");
  const [fxRateType, setFxRateType] = useState<string>("0");
  const [orderCharge, setOrderCharge] = useState<string>("0");
  const [returnCharge, setReturnCharge] = useState<string>("0");
  const [rateCardEmailAddresses, setRateCardEmailAddresses] = useState<
    string[]
  >([]);
  const [isDirty, setIsDirty] = useState<boolean>(false);
  const [clickedActionButton, setClickedActionButton] = useState<boolean>(
    false
  );
  const [value, setValue] = React.useState(0);
  const [margin, setMargin] = useState<any>("0");
  const [poundCharge, setPoundCharge] = useState<any>("0");
  const [percentageCharge, setPercentageCharge] = useState<any>("0");
  const [poundMinimum, setPoundMinimum] = useState<any>("0");
  const [currency, setCurrency] = useState<string | null>(null);
  const [direction, setDirection] = useState<string>("0");
  const [settlement, setSettlement] = useState<string>("0");
  const [buyOrSellError, setBuyOrSellError] = useState<boolean>(false);
  const [sameComboError, setSameComboError] = useState<boolean>(false);
  const [noMarginsOrChargeError, setNoMarginsOrChargeError] = useState<boolean>(
    false
  );
  const [marginsAndCharges, setMarginsAndCharges] = useState<any[]>([]);
  const [selectedItems, setSelectedItems] = useState<any[]>([]);
  const [selectAllChecked, setSelectAllChecked] = useState<boolean>(false);
  const [openModal, setOpenModal] = useState<boolean>(false);
  const [fcaCurrencies, setFcaCurrencies] = useState<any[]>([]);

  const handleTabChange = (event: any, newValue: any) => {
    setValue(newValue);
  };

  useEffect(() => {
    setClickedActionButton(false);
    setSameComboError(false);
    setNoMarginsOrChargeError(false);

    if (props.value && props.value.id) {
      setName(props.value.name);
      setFxRateType(
        props.value.fxRateType && props.value.fxRateType.toString()
      );
      setRateCardEmailAddresses(
        props.value.rateCardEmailAddresses && props.value.rateCardEmailAddresses
      );
      setOrderCharge(
        props.value.orderCharge && props.value.orderCharge.toString()
      );
      setReturnCharge(
        props.value.returnCharge && props.value.returnCharge.toString()
      );
      setReturnCharge(
        props.value.returnCharge && props.value.returnCharge.toString()
      );
      setMarginsAndCharges(
        (props.value.marginsAndCharges && props.value.marginsAndCharges) || []
      );
      setFcaCurrencies(
        props.currencies.filter((x: any) =>
          props.value.fcaCurrencies.includes(x.id)
        ) || []
      );
    } else {
      setFxRateType("0");
      setName("");
      setRateCardEmailAddresses([]);
      setOrderCharge("0");
      setReturnCharge("0");
      setFcaCurrencies([]);
      clearMarginsSection();
    }
  }, [props.open, props.value]);

  useEffect(() => {
    if (parseFloat(poundCharge)) {
      setPoundMinimum("0");
      setPercentageCharge("0");
    }
  }, [poundCharge]);

  useEffect(() => {
    // if (currency === null || "All") {
    //   setSettlement("0");
    // }
  }, [currency]);

  useEffect(() => {
    if (settlement === "1") {
      setMargin("0");
      setPoundMinimum("0");
    }
  }, [settlement]);

  function handleDeleteButtonClick() {
    setOpenModal(true);
  }

  function handleConfirmDeleteClick() {
    if (selectedItems.length > 0) {
      let a = marginsAndCharges;
      selectedItems.forEach((x: any) => {
        a = a.filter((mac: any) => mac !== x);
      });

      setMarginsAndCharges(a || []);

      setSelectAllChecked(!selectAllChecked);
      setSelectedItems([]);
    }
    setOpenModal(false);
  }

  function handleCreate() {
    setClickedActionButton(true);

    if (name === "") {
      setIsDirty(true);
    } else {
      setIsDirty(false);
      clearMarginsSection();

      props.onCreate({
        name,
        fxRateType,
        rateCardEmailAddresses,
        orderCharge,
        returnCharge,
        marginsAndCharges,
        fcaCurrencies,
        settlement
      });
    }
    setValue(0);
  }

  function handleUpdate() {
    setClickedActionButton(true);

    if (name === "") {
      setIsDirty(true);
    } else {
      setIsDirty(false);
      clearMarginsSection();
      props.onUpdateCompany({
        name,
        fxRateType,
        rateCardEmailAddresses,
        orderCharge,
        returnCharge,
        marginsAndCharges,
        fcaCurrencies,
        settlement
      });
    }
    setValue(0);
  }

  function clearMarginsSection() {
    setMargin("0");
    setPoundCharge("0");
    setPercentageCharge("0");
    setPoundMinimum("0");
    setCurrency(null);
    setDirection("0");
    setBuyOrSellError(false);
    setMarginsAndCharges([]);
  }

  function clearMarginsFields() {
    setMargin("0");
    setPoundCharge("0");
    setPercentageCharge("0");
    setPoundMinimum("0");
    setCurrency(null);
    setDirection("0");
    setBuyOrSellError(false);
  }

  function handleAddEmailAddress(email: any) {
    setRateCardEmailAddresses((emails: any) => emails.concat([email]));
  }

  function handleRemoveEmailAddress(email: any, index: number) {
    setRateCardEmailAddresses((emails: any) =>
      emails.filter((x: any) => x !== email)
    );
  }

  function handleRateTypeChange(evt: any) {
    setFxRateType(evt.target.value);

    if (evt.target.value === "0") {
      setRateCardEmailAddresses([]);
    }
  }

  function handleClose() {
    setIsDirty(false);
    setClickedActionButton(false);
    clearMarginsSection();
    setValue(0);
    props.close();
  }

  function handleAddMargin() {
    setSameComboError(false);
    setNoMarginsOrChargeError(false);

    if (direction === "0") {
      setBuyOrSellError(true);
    } else {
      setBuyOrSellError(false);
      if (
        marginsAndCharges.some(
          mac =>
            mac.direction === (direction === "1" ? 0 : 1) &&
            mac.currencyId === currency &&
            mac.settlementSource === parseInt(settlement)
        )
      ) {
        setSameComboError(true);
      } else if (
        parseFloat(margin) === 0 &&
        parseFloat(poundCharge) === 0 &&
        parseFloat(percentageCharge) === 0
      ) {
        setNoMarginsOrChargeError(true);
      } else {
        setSameComboError(false);
        updateMarginTable();
        clearMarginsFields();
      }
    }
  }

  function updateMarginTable() {
    setMarginsAndCharges([
      ...marginsAndCharges,
      {
        direction: direction === "1" ? 0 : 1,
        marginPercent: margin === "0" ? null : parseFloat(margin),
        chargeAbsolute: poundCharge === "0" ? null : parseFloat(poundCharge),
        chargePercent:
          percentageCharge === "0" ? null : parseFloat(percentageCharge),
        minimumCharge:
          parseFloat(poundCharge) > 0 ? null : parseFloat(poundMinimum),
        currencyId: currency,
        // Settlement source is 0 = Base (GBP), 1 = FCA
        settlementSource: parseInt(settlement)
      }
    ]);
  }

  function getCurrency(currencyId: number): string {
    if (props.currencies) {
      const currency = props.currencies.find(
        (c: Currency) => c.id === currencyId
      );
      if (currency) {
        return `${currency.region} - ${currency.name}`;
      }
    }
    return "";
  }

  function getCurrencyCode(currencyId: number): string {
    if (props.currencies) {
      const currency = props.currencies.find(
        (c: Currency) => c.id === currencyId
      );
      if (currency) {
        return currency.code;
      }
    }
    return "";
  }

  function getSettlementCurrencySymbol(
    settlementSource: number,
    currencyId: number
  ) {
    if (settlementSource == 1) {
      const code = getCurrencyCode(currencyId);
      if (code !== "") {
        return `${code}`;
      }
    }

    return "£";
  }

  return (
    <>
      <Dialog
        className="CompanyCreationModal-dialog"
        open={props.open}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        fullWidth={true}
        maxWidth={"lg"}
      >
        <DialogTitle className={classes.titleBar}>
          {props.action === "Add" ? "Create Company" : "Edit Company"}
        </DialogTitle>
        <DialogContent>
          <div className={`${classes.root}`}>
            <Tabs
              value={value}
              onChange={handleTabChange}
              indicatorColor="primary"
              textColor="primary"
            >
              <Tab
                className={`${classes.tabLabel} CompanyCreationModal-detailsTab`}
                label="Details"
              />
              <Tab
                className={`${classes.tabLabel} CompanyCreationModal-marginsTab`}
                label="Margins"
              />
              <Tab
                className={`${classes.tabLabel} CompanyCreationModal-fcaSettlementsTab`}
                label="FCA Settlements"
              />
            </Tabs>
            <TabPanel value={value} index={0}>
              <div>
                <div className="CompanyDetails--formContainer">
                  <InputField
                    containerClassName={"CompanyDetails-CompanyName"}
                    fieldName={"Company Name"}
                    textFieldClassName={"CompanyDetails-CompanyName-text"}
                    type={"text"}
                    value={name}
                    inputProps={{ maxLength: "50" }}
                    onChange={(evt: any) => setName(evt.target.value)}
                    placeHolder={"Required"}
                    errorOutline={isDirty && name === ""}
                    errorMessage={
                      isDirty && name === "" ? "Enter a company name" : ""
                    }
                    errorMessageClassName={"CompanyDetails-errorMsgText"}
                    clickedActionButton={clickedActionButton}
                  />
                  <div className="InputField--input-container CompanyDetails-fxRateTypes">
                    <div className="InputField--input-label">Rate Updates</div>
                    <FormControl component="fieldset">
                      <RadioGroup
                        className={classes.radioGroup}
                        aria-label="Rate Updates"
                        name="Rate Updates"
                        value={fxRateType === "1" ? "1" : "0"} //TODO: seems to not set the radiobutton value to "0" on edit - so forcing it to
                        onChange={(evt: any) => handleRateTypeChange(evt)}
                      >
                        <FormControlLabel
                          value="0"
                          control={<Radio className="FxRateTypes-Live" />}
                          label="Live"
                        />
                        <FormControlLabel
                          value="1"
                          control={<Radio className="FxRateTypes-Daily" />}
                          label="Daily"
                        />
                      </RadioGroup>
                    </FormControl>
                  </div>
                  <div className="InputField--input-container CompanyDetails-EmailDailyRatesTo">
                    <div className="InputField--input-label">
                      Email Daily Rates To
                    </div>
                    <div className="CompanyDetails-ChipInputContainer">
                      <ChipInput
                        variant={"outlined"}
                        className="CompanyDetails-EmailDailyRatesToField"
                        disabled={fxRateType !== "1"}
                        value={rateCardEmailAddresses}
                        onAdd={chip => handleAddEmailAddress(chip)}
                        onDelete={(chip, index) =>
                          handleRemoveEmailAddress(chip, index)
                        }
                        newChipKeys={["Enter", "SpaceBar", " "]}
                      />
                      {rateCardEmailAddresses &&
                      rateCardEmailAddresses.length > 0 ? (
                        <Button
                          className="CompanyDetails-clearEmailsButton"
                          color="primary"
                          startIcon={<BackspaceIcon />}
                          onClick={() => setRateCardEmailAddresses([])}
                        />
                      ) : (
                        <></>
                      )}
                    </div>
                  </div>
                  <InputField
                    containerClassName={"CompanyDetails-OrderCharge"}
                    fieldName={"Order Charge"}
                    textFieldClassName={"CompanyDetails-OrderCharge-text"}
                    type={"number"}
                    value={orderCharge}
                    onChange={(evt: any) => {
                      let pv;
                      if (parseFloat(evt.target.value) < 0) {
                        pv = Math.abs(evt.target.value).toString();
                      } else {
                        pv = evt.target.value;
                      }

                      if (pv === "NaN") {
                        setOrderCharge("0");
                      } else {
                        setOrderCharge(pv);
                      }
                    }}
                  />
                  <InputField
                    containerClassName={"CompanyDetails-ReturnCharge"}
                    fieldName={"Return Charge"}
                    textFieldClassName={"CompanyDetails-ReturnCharge-text"}
                    type={"number"}
                    value={returnCharge}
                    onChange={(evt: any) => {
                      let pv;
                      if (parseFloat(evt.target.value) < 0) {
                        pv = Math.abs(evt.target.value).toString();
                      } else {
                        pv = evt.target.value;
                      }

                      if (pv === "NaN") {
                        setReturnCharge("0");
                      } else {
                        setReturnCharge(pv);
                      }
                    }}
                  />{" "}
                </div>
              </div>
            </TabPanel>
            <TabPanel value={value} index={1}>
              <>
                <div className="CompanyDetails-MainMarginsContainer">
                  <div className="CompanyDetails-MarginsContainer">
                    <div className="InputField--input-container CompanyDetails-buyOrSell">
                      <div className="InputField--input-label">Buy/Sell</div>
                      <FormControl component="fieldset" error={buyOrSellError}>
                        <RadioGroup
                          className={classes.radioGroup}
                          aria-label="Buy/Sell"
                          name="Buy/Sell"
                          value={
                            direction === "2"
                              ? "2"
                              : direction === "1"
                              ? "1"
                              : "0"
                          } //TODO: seems to not set the radiobutton value to "0" on edit - so forcing it to
                          onChange={(evt: any) =>
                            setDirection(evt.target.value)
                          }
                        >
                          <FormControlLabel
                            value="0"
                            control={<Radio className="BuyOrSell-None" />}
                            label="None"
                          />
                          <FormControlLabel
                            value="2"
                            control={<Radio className="BuyOrSell-Buy" />}
                            label="Buy"
                          />
                          <FormControlLabel
                            value="1"
                            control={<Radio className="BuyOrSell-Sell" />}
                            label="Sell"
                          />
                        </RadioGroup>
                        <FormHelperText
                          className={`${classes.errorMsg} CompanyMargins-DirectionErrorMsg`}
                        >
                          {buyOrSellError ? "Select a type" : ""}
                        </FormHelperText>
                      </FormControl>
                    </div>
                    <DropDown
                      containerClassName={"CompanyMargins-Currency"}
                      fieldName={"Currency"}
                      value={currency || ""}
                      renderValue={(currency: any) => {
                        if (currency === "") {
                          return (
                            <MenuItem
                              className={classes.dropDownField}
                              disabled
                              key=""
                              value="All"
                            >
                              All
                            </MenuItem>
                          );
                        } else {
                          return getCurrency(currency);
                        }
                      }}
                      onChange={(event: any) =>
                        setCurrency(event.target.value as string)
                      }
                      errorOutline={null}
                      defaultDropDownItem={
                        <MenuItem
                          className={classes.dropDownField}
                          key=""
                          value="All"
                        >
                          All
                        </MenuItem>
                      }
                      dropDownItems={
                        props.currencies &&
                        props.currencies.map(
                          (currency: Currency, i: number) => (
                            <MenuItem
                              className={classes.dropDownField}
                              key={i}
                              value={currency.id}
                            >
                              {currency.region} - {currency.name}
                            </MenuItem>
                          )
                        )
                      }
                    />
                    <InputField
                      disabled={settlement === "1"}
                      containerClassName={"CompanyDetails-Margin"}
                      fieldName={"Margin (%)"}
                      textFieldClassName={"CompanyDetails-Margin-text"}
                      type={"number"}
                      value={margin}
                      onChange={(evt: any) => {
                        let pv;
                        if (parseFloat(evt.target.value) < 0) {
                          pv = Math.abs(evt.target.value).toString();
                        } else {
                          pv = evt.target.value;
                        }

                        if (pv === "NaN") {
                          setMargin("0");
                        } else {
                          setMargin(pv);
                        }
                      }}
                      errorMessage={
                        parseFloat(margin) > 5
                          ? "Suggested maximum margin is 5%. Please verify the margin before saving."
                          : parseFloat(margin) > 0 && parseFloat(margin) < 0.3
                          ? "Suggested minimum margin is 0.3%. Please verify the margin before saving."
                          : ""
                      }
                      errorMessageClassName={"CompanyMargins-MarginErrorMsg"}
                      errorOutline={noMarginsOrChargeError}
                    />
                    <InputField
                      disabled={parseFloat(percentageCharge) > 0}
                      containerClassName={"CompanyDetails-CurrencyCharge"}
                      fieldName={`Charge (${getSettlementCurrencySymbol(
                        parseInt(settlement),
                        parseInt(currency || "")
                      )})`}
                      textFieldClassName={"CompanyDetails-CurrencyCharge-text"}
                      type={"number"}
                      value={poundCharge}
                      onChange={(evt: any) => {
                        let pv;
                        if (parseFloat(evt.target.value) < 0) {
                          pv = Math.abs(evt.target.value).toString();
                        } else {
                          pv = evt.target.value;
                        }

                        if (pv === "NaN") {
                          setPoundCharge("0");
                        } else {
                          setPoundCharge(pv);
                        }
                      }}
                      errorMessage={
                        parseFloat(poundCharge) > 10
                          ? "Suggested maximum charge is £10. Please verify the charge before saving."
                          : parseFloat(poundCharge) > 0 &&
                            parseFloat(poundCharge) < 0.5
                          ? "Suggested minimum charge is £0.5. Please verify the charge before saving."
                          : ""
                      }
                      errorOutline={noMarginsOrChargeError}
                    />
                    <InputField
                      disabled={parseFloat(poundCharge) > 0}
                      containerClassName={"CompanyDetails-PercentageCharge"}
                      fieldName={"Charge (%)"}
                      textFieldClassName={
                        "CompanyDetails-PercentageCharge-text"
                      }
                      type={"number"}
                      value={percentageCharge}
                      onChange={(evt: any) => {
                        let pv;
                        if (parseFloat(evt.target.value) < 0) {
                          pv = Math.abs(evt.target.value).toString();
                        } else {
                          pv = evt.target.value;
                        }

                        if (pv === "NaN") {
                          setPercentageCharge("0");
                        } else {
                          setPercentageCharge(pv);
                        }
                      }}
                      errorOutline={noMarginsOrChargeError}
                      errorMessage={
                        parseFloat(percentageCharge) > 3.5
                          ? "Suggested maximum charge is 3.5%. Please verify the charge before saving."
                          : parseFloat(percentageCharge) > 0 &&
                            parseFloat(percentageCharge) < 0.5
                          ? "Suggested minimum charge is 0.5%. Please verify the charge before saving."
                          : ""
                      }
                    />
                    <InputField
                      disabled={
                        parseFloat(poundCharge) > 0 || settlement === "1"
                      }
                      containerClassName={"CompanyDetails-CurrencyMin"}
                      fieldName={`Minimum (${getSettlementCurrencySymbol(
                        parseInt(settlement),
                        parseInt(currency || "")
                      )})`}
                      textFieldClassName={"CompanyDetails-CurrencyMin-text"}
                      type={"number"}
                      value={poundMinimum}
                      onChange={(evt: any) => {
                        let pv;
                        if (parseFloat(evt.target.value) < 0) {
                          pv = Math.abs(evt.target.value).toString();
                        } else {
                          pv = evt.target.value;
                        }

                        if (pv === "NaN") {
                          setPoundMinimum("0");
                        } else {
                          setPoundMinimum(pv);
                        }
                      }}
                    />
                  </div>
                  <div className="CompanyDetails-MarginsContainer">
                    <div className="InputField--input-container CompanyDetails-settlement">
                      <div className="InputField--input-label">Settlement</div>
                      <FormControl component="fieldset">
                        <RadioGroup
                          className={classes.radioGroup}
                          aria-label="Settlement"
                          name="Settlement"
                          value={settlement === "1" ? "1" : "0"} //TODO: seems to not set the radiobutton value to "0" on edit - so forcing it to
                          onChange={(evt: any) => {
                            setSettlement(evt.target.value);
                          }}
                        >
                          <FormControlLabel
                            value="0"
                            control={
                              <Radio
                                disabled={
                                  currency === null ||
                                  currency === "All" ||
                                  fcaCurrencies.length === 0 ||
                                  !fcaCurrencies
                                    .map((x: any) => x.id)
                                    .includes(currency)
                                }
                                className="Settlement-UkPound"
                              />
                            }
                            label="UK-Pound"
                          />
                          <FormControlLabel
                            value="1"
                            control={
                              <Radio
                                disabled={
                                  currency === null ||
                                  currency === "All" ||
                                  fcaCurrencies.length === 0 ||
                                  !fcaCurrencies
                                    .map((x: any) => x.id)
                                    .includes(currency)
                                }
                                className="Settlement-FCA"
                              />
                            }
                            label="FCA"
                          />
                        </RadioGroup>
                      </FormControl>
                    </div>
                  </div>
                </div>

                <div className="CompanyDetails-ActionBar">
                  <div>
                    {sameComboError ? (
                      <div className="CompanyDetails-comboErrorMsg">
                        Cannot add the same combination of <b>Buy/Sell</b>,{" "}
                        <b>Currency</b> and Settlement.
                      </div>
                    ) : noMarginsOrChargeError ? (
                      <div className="CompanyDetails-noMarginsOrChargeError">
                        Must set <b>Margin</b> or <b>Charge</b>
                      </div>
                    ) : (
                      <></>
                    )}
                  </div>
                  <div>
                    {selectedItems.length > 0 ? (
                      <Button
                        variant="contained"
                        className={`${classes.button} CompanyDetails-DeleteMarginButton`}
                        color="secondary"
                        startIcon={
                          <DeleteIcon className="CompanyDetails-deleteIcon" />
                        }
                        onClick={() => handleDeleteButtonClick()}
                      >
                        Delete Margin
                      </Button>
                    ) : (
                      <></>
                    )}
                    <Button
                      variant="contained"
                      className={`${classes.button} CompanyDetails-AddMarginButton`}
                      color="primary"
                      startIcon={<AddIcon className="CompanyDetails-addIcon" />}
                      onClick={() => handleAddMargin()}
                    >
                      Add Margin
                    </Button>
                  </div>
                </div>

                <div>
                  <table className="MarginsTable-container">
                    <thead className="MarginsTable--headPanel">
                      <tr className="MarginsTable--headPanelRow">
                        <th>
                          <Checkbox
                            disabled={
                              !marginsAndCharges ||
                              marginsAndCharges.length === 0
                            }
                            className="BasketList-selectAll"
                            inputProps={{ "aria-label": "primary checkbox" }}
                            checked={selectAllChecked}
                            onChange={event => {
                              setSelectAllChecked(!selectAllChecked);
                              if (event.target.checked) {
                                setSelectedItems(marginsAndCharges);
                              } else {
                                setSelectedItems([]);
                              }
                            }}
                          />
                        </th>
                        <th>Buy/Sell</th>
                        <th>Currency</th>
                        <th>Margin (%)</th>
                        <th>Charge (flat)</th>
                        <th>Charge (%)</th>
                        <th>Min Charge</th>
                        <th>Settlement</th>
                      </tr>
                    </thead>
                    <tbody>
                      {marginsAndCharges &&
                        marginsAndCharges.map((data: any) => (
                          <tr className="MarginsTable--row">
                            <td className="BasketItem-selectBasketItem">
                              <Checkbox
                                className="BasketItem-selectBasketItemCheckBox"
                                inputProps={{
                                  "aria-label": "primary checkbox"
                                }}
                                checked={selectedItems.includes(data)}
                                onChange={event => {
                                  if (event.target.checked) {
                                    setSelectedItems(() => [
                                      ...selectedItems,
                                      data
                                    ]);
                                  } else {
                                    setSelectedItems((item: any[]) => {
                                      const result = [...item];
                                      if (result.indexOf(data) !== -1) {
                                        result.splice(result.indexOf(data), 1);
                                      }
                                      return result;
                                    });
                                  }
                                }}
                              />
                            </td>
                            <td>{data.direction === 0 ? "Sell" : "Buy"}</td>
                            <td>
                              {data.currencyId === null
                                ? "All currencies"
                                : getCurrency(data.currencyId)}
                            </td>
                            <td>
                              {data.marginPercent
                                ? `${data.marginPercent.toLocaleString(
                                    navigator.language,
                                    {
                                      minimumFractionDigits: 2
                                    }
                                  )}%`
                                : ``}
                            </td>
                            <td>
                              {data.chargeAbsolute
                                ? `${getSettlementCurrencySymbol(
                                    data.settlementSource,
                                    data.currencyId
                                  )}${data.chargeAbsolute.toLocaleString(
                                    navigator.language,
                                    {
                                      minimumFractionDigits: 2
                                    }
                                  )}`
                                : ``}
                            </td>
                            <td>
                              {data.chargePercent
                                ? `${data.chargePercent.toLocaleString(
                                    navigator.language,
                                    {
                                      minimumFractionDigits: 2
                                    }
                                  )}%`
                                : ``}
                            </td>
                            <td>
                              {data.minimumCharge
                                ? `${getSettlementCurrencySymbol(
                                    data.settlementSource,
                                    data.currencyId
                                  )}${data.minimumCharge.toLocaleString(
                                    navigator.language,
                                    {
                                      minimumFractionDigits: 2
                                    }
                                  )}`
                                : ``}
                            </td>
                            <td>
                              {data.settlementSource === 0 ? (
                                <>UK-Pound</>
                              ) : (
                                <>FCA</>
                              )}
                            </td>
                          </tr>
                        ))}
                    </tbody>
                  </table>
                  {marginsAndCharges.length === 0 ? (
                    <div className="MarginsTable--noDataContainer">
                      <StorageIcon className="MarginsTable--noDataIcon" />
                      <p className="MarginsTable--noDataText">
                        There are currently no margins to display.
                      </p>
                    </div>
                  ) : (
                    <></>
                  )}
                </div>
              </>
            </TabPanel>
            <TabPanel value={value} index={2}>
              <div>
                <div className="CompanyDetails--input-container CompanyDetails-fcaSettlements">
                  <div className="CompanyDetails--input-label">
                    Selected Settlements
                  </div>
                  <Autocomplete
                    multiple
                    id="checkboxes-tags-demo"
                    options={props && props.currencies}
                    value={fcaCurrencies}
                    disableCloseOnSelect
                    filterSelectedOptions
                    getOptionLabel={(option: any) =>
                      `${option.region} - ${option.name}`
                    }
                    onChange={(evt, values) => {
                      setFcaCurrencies(values);
                    }}
                    renderOption={(option, { selected }) => (
                      <React.Fragment>
                        <Checkbox
                          icon={icon}
                          checkedIcon={checkedIcon}
                          style={{ margin: 5 }}
                          checked={selected}
                        />
                        {option.region} - {option.name}
                      </React.Fragment>
                    )}
                    style={{ width: 550, marginLeft: 5 }}
                    renderInput={params => (
                      <TextField
                        {...params}
                        variant="outlined"
                        placeholder="Foreign Currencies"
                      />
                    )}
                  />
                </div>
              </div>
            </TabPanel>
          </div>
        </DialogContent>
        <DialogActions>
          <Button
            className="CompanyCreationModal-cancel"
            color="secondary"
            onClick={() => handleClose()}
          >
            Cancel
          </Button>

          {props.action === "Add" ? (
            <Button
              className="CompanyCreationModal-create"
              color="primary"
              onClick={() => handleCreate()}
            >
              Create
            </Button>
          ) : (
            <Button
              className="CompanyCreationModal-save"
              color="primary"
              onClick={() => handleUpdate()}
            >
              Save
            </Button>
          )}
        </DialogActions>
      </Dialog>
      <Dialog
        className="BasketList-confirmationDialog"
        open={openModal}
        onClose={() => setOpenModal(false)}
      >
        <DialogTitle id="alert-dialog-slide-title">
          {"Delete Selected Items"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
            Are you sure you want to delete{" "}
            {selectedItems.length > 1 ? "these " : "this "}
            <b>{selectedItems.length}</b> selected{" "}
            {selectedItems.length > 1 ? "items" : "item"}?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            className="BasketList-confirmationDialogCancel"
            onClick={() => setOpenModal(false)}
            color="secondary"
          >
            Cancel
          </Button>
          <Button
            className="BasketList-confirmationDialogConfirm"
            color="primary"
            onClick={() => handleConfirmDeleteClick()}
          >
            Confirm
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default CompanyCreationModal;
